// Archivo: assets/p-custom.js

// LOG AMARILLO 
// usage: clg( "test", {{  product | json }})
window.clg = function(...args) {
  console.log('%c' + args[0], 'color: yellow', ...args.slice(1));
}
 

// VIDEO BUTTON PLAY EN TODAS LAS SECCIONES NUESTRAS
// lo utilizamos en p-media-and-text.liquid y p-slider-video.liquid
function initVideoPlay(section) {
  function pauseAll(except) {
    document.querySelectorAll('video').forEach(v => {
      if (v !== except) {
        v.pause();
        v.removeAttribute('controls');
        v.closest('.relative').classList.remove('is-playing');
      }
    });
  }

  section.querySelectorAll('.play-video').forEach(btn => {
    btn.addEventListener('click', () => {
      const parentElement = btn.closest('.relative');
      const video = parentElement.querySelector('video');
      pauseAll(video);
      video.setAttribute('controls', '');
      video.play();
      parentElement.classList.add('is-playing');
    });
  });

  section.querySelectorAll('video').forEach(video => {
    video.addEventListener('pause', () => {
      video.removeAttribute('controls');
      video.closest('.relative').classList.remove('is-playing');
    });
    video.addEventListener('ended', () => {
      video.removeAttribute('controls');
      video.closest('.relative').classList.remove('is-playing');
    });
  });
}

 